export default function (Alpine) {
    Alpine.directive('fetch', (el, { value, modifiers, expression }, { evaluate, effect, cleanup }) => {
        var config = evaluate(expression);
        if (config == undefined)
            return;
        let url = config.url || "";
        modifiers["url"] = config.url;
        if (url == "") {
            return;
        }
        let target = config.target || "self";
        let targetEl;
        if (target == "self" || target == "")
            targetEl = el;
        else
            targetEl = document.querySelector(target);
        fetch(url)
            .then(response => {
            if (response.ok && targetEl) {
                response.text().then(text => {
                    targetEl.innerHTML = text;
                    if (config.success)
                        config.success(text, targetEl);
                });
            }
            else if (config.error)
                config.error(response);
        }).catch(error => {
            if (config.error)
                config.error(error);
        });
    });
}
